import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { StatisticsRepository } from "../statistics.repository";

@Injectable({
    providedIn: "root"
})
export class RefetchBetRecordsUseCase implements IUseCase<void, void> {
    constructor(private statisticsRepository: StatisticsRepository) {
    }

    execute(): void {
        this.statisticsRepository.refetchBetRecords();
    }
}
